import { render } from "./WOrganizationEditionForm.vue?vue&type=template&id=2927d2cc&scoped=true&ts=true"
import script from "./WOrganizationEditionForm.vue?vue&type=script&lang=ts"
export * from "./WOrganizationEditionForm.vue?vue&type=script&lang=ts"

import "./WOrganizationEditionForm.vue?vue&type=style&index=0&id=2927d2cc&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2927d2cc"]])

export default __exports__